module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/172.5b2eda64.png";